import GameShell from './GameShell';
import DailyResultOverlay from './DailyResultOverlay';
import { getResult, getStatus } from '../dailySession';
import type { GameId } from '../games';

/**
 * Screen for a daily that's already resolved.
 *
 * Rendered instead of the game, not on top of it — a finished round shouldn't
 * mount a playable board at all, so there's nothing behind the overlay to
 * interact with and no game logic running.
 */
export default function FinishedDaily({
  gameId,
  dateKey,
  isToday,
}: {
  gameId: GameId;
  dateKey: string;
  isToday: boolean;
}) {
  const status = getStatus(gameId, dateKey);
  const result = getResult(gameId, dateKey);

  return (
    <GameShell gameId={gameId} subtitle="Today's round is complete">
      <DailyResultOverlay
        outcome={status === 'lost' ? 'lost' : 'won'}
        result={result}
        dateKey={dateKey}
        isToday={isToday}
      />
    </GameShell>
  );
}
